import { get } from 'lodash';
import { createMuiTheme } from '@material-ui/core/styles';

/**
 * Colors palette definition
 * https://material-ui.com/customization/themes/
 */
const palette = {
  primary: {
    light: '#4279a0', // Light blue
    main: '#004D71',
    dark: '#002545',
  },
  secondary: {
    light: '#ff843c', // Orange
    main: '#FF5000',
    dark: '#c30c00',
  },
  helpers: {
    orange: '#F7931E',
    contrastText: '#FFF',
    green: '#8CC63F',
    red: '#FF0000',
    gray: '#999',
    darkGray: '#333'
  },
  default: {
    color: '#6A696A',
    background: '#E5F2FB'
  },
  background: {
    paper: '#FFF',
    default: '#FFF'
  },
  shape: {
    borderRadius: 40
  },

  // progress colors
  progressLevel: {
    HIGHEST: '#5E96BF',
    HIGH: '#58AA84',
    MEDIUM_HIGH: '#A0A749',
    MEDIUM_LOW: '#E09F3F',
    LOW: '#A23D48',
    LOWEST: '#74A0C4'
  }
};

/**
 * Typography definition
 * https://material-ui.com/style/typography/
 */
const typography = {
  // Use the system font instead of the default Roboto font.
  fontFamily: "'Roboto', 'Helvetica', 'Arial'",
  fontSize: 12,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightExtra: 700,

  headline: {
    color: `${get(palette, 'primary.dark')}`,
    marginBottom: 28,
    fontSize: 32,
    fontWeight: 800
  },

  title: {
    color: `${get(palette, 'primary.main')}`,
    marginBottom: 8,
    fontSize: 24,
    fontWeight: 800
  },

  body1: {
    fontSize: 16
  }
};

/**
 * Overrides UI elements
 * For documentation to get all UI component's name go to:
 * https://material-ui.com/
 * Props: https://material-ui.com/customization/default-theme/
 */
const overrides = {
  /**
   * Buttons
   * https://material-ui.com/api/button/
   */
  MuiButton: {
    root: {
      textTransform: 'none'
    },

    contained: {
      boxShadow: 'none',
      fontSize: '1rem',
      fontWeight: 800
    }
  },
  /**
   * Panels
   * https://material-ui.com/api/paper/
   */
  MuiPaper: {
    root: {
      border: `1px solid ${get(palette, 'primary.main')}`,
      borderRadius: 1,
      boxShadow: 'none'
    }
  },
  /**
   * Inputs
   * https://material-ui.com/api/input/
   */
  MuiInput: {
    root: {
      border: 'none',
      color: `${get(palette, 'primary.dark')}`,
      '&:after': {
        content: 'none !important'
      },
      '&:before': {
        content: 'none !important'
      }
    }
  },
  /**
   * Inputs
   * https://material-ui.com/api/input/
   */
  MuiTextField: {
    root: {
      border: 'none',
      padding: '3px 1px 3px 10px',
      borderRadius: 0,
      '&:after': {
        content: 'none !important'
      },
      '&:before': {
        content: 'none !important'
      }
    }
  },
  MuiInputBase: {
    input: {
      border: 'none',
      borderRadius: 0,
      '&:after': {
        content: 'none !important'
      },
      '&:before': {
        content: 'none !important'
      }
    }
  },
  MuiFormLabel: {
    root: {
      marginLeft: 10,
      marginTop: 4
    }
  },
  /**
   * Typography
   * https://material-ui.com/api/typography/
   */
  MuiTypography: {
    body1: typography.body1
  }
};

const theme = createMuiTheme({
  palette,
  typography,
  overrides
});

export default theme;
